module.exports = __webpack_public_path__ + "img/Insta.ed489473.png";